<script setup>
import { ref, watch } from "vue";
import { $dt } from "@primevue/themes";

import { useLayout } from "@/layout/composables/layout";

const { isDarkMode } = useLayout();

const neenaDarkgreen = $dt("stone.500").value;
const stone400 = $dt("stone.400").value;

const fillColor = ref(neenaDarkgreen);

function toggleTheme() {
  if (!isDarkMode.value) {
    fillColor.value = neenaDarkgreen;
  } else {
    fillColor.value = stone400;
  }
}

toggleTheme();

watch(isDarkMode, () => {
  toggleTheme();
});
</script>

<template>
  <svg
    width="21"
    height="28"
    viewBox="0 0 21 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.44067 14.5557C7.52691 14.5553 7.61237 14.5719 7.69203 14.6047C7.77169 14.6375 7.84394 14.6857 7.90455 14.7465L10.5303 17.3481L13.156 14.7465C13.2832 14.6856 13.4267 14.667 13.5654 14.6934C13.704 14.7199 13.8304 14.7899 13.9257 14.8931C14.0211 14.9963 14.0803 15.1272 14.0945 15.2664C14.1088 15.4056 14.0774 15.5456 14.005 15.6657L10.9416 18.7009C10.8186 18.8227 10.6517 18.8911 10.4778 18.8911C10.3038 18.8911 10.137 18.8227 10.0139 18.7009L6.95053 15.6657C6.8276 15.5437 6.75855 15.3784 6.75855 15.2061C6.75855 15.0337 6.8276 14.8684 6.95053 14.7465C7.01419 14.6824 7.09071 14.6323 7.17514 14.5995C7.25958 14.5666 7.35004 14.5517 7.44067 14.5557Z"
      :fill="fillColor"
    />
    <path
      d="M13.5595 12.5745C13.4732 12.5749 13.3877 12.5582 13.3081 12.5254C13.2284 12.4927 13.1562 12.4445 13.0956 12.3837L10.4698 9.78206L7.8441 12.3837C7.71695 12.4445 7.57339 12.4631 7.43473 12.4367C7.29607 12.4103 7.16971 12.3403 7.07438 12.2371C6.97906 12.1338 6.91987 12.0029 6.90559 11.8638C6.89131 11.7246 6.9227 11.5845 6.99511 11.4644L10.0585 8.42923C10.1816 8.30743 10.3484 8.23901 10.5224 8.23901C10.6963 8.23901 10.8632 8.30743 10.9862 8.42923L14.0496 11.4644C14.1725 11.5864 14.2416 11.7517 14.2416 11.9241C14.2416 12.0964 14.1725 12.2617 14.0496 12.3837C13.9859 12.4477 13.9094 12.4978 13.825 12.5306C13.7405 12.5635 13.6501 12.5784 13.5595 12.5745Z"
      :fill="fillColor"
    />
  </svg>
</template>
